// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var React       = require("react");
var Pervasives  = require("bs-platform/lib/js/pervasives.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

((require('./Title.css')));

var component = ReasonReact.statelessComponent("Title");

function make(score, _, _$1) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      return React.createElement("div", {
                  className: "App-header"
                }, React.createElement("h2", undefined, "RR 2048"), React.createElement("div", {
                      className: "scoreArea"
                    }, React.createElement("div", {
                          className: "scoreAreaInner"
                        }, React.createElement("div", {
                              className: "scoreLabel"
                            }, "Total"), React.createElement("div", {
                              className: "score"
                            }, Pervasives.string_of_int(score)))));
    });
  return newrecord;
}

exports.component = component;
exports.make      = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/components/Title.re
// module id = 35
// module chunks = 0